import { Component, Prop } from 'vue-property-decorator';
import { DialogFormClass } from '@/core';
import { DialogWindow } from '@/components';
import { DriverInfo } from '@/pages/TripsPage/interfaces/driverInfo.interface';
import { VehicleInfo } from '@/pages/TripsPage/interfaces/vehicleInfo.interface';
import ImageViewDialog from './components/ImageViewDialog/ImageViewDialog.vue';

@Component({
  components: { ImageViewDialog, DialogWindow },
})
export default class DocumentsDialog extends DialogFormClass {
  @Prop({ required: false })
  private readonly driverInfo: DriverInfo | undefined;

  @Prop({ required: false })
  private readonly vehicleInfo: VehicleInfo | undefined;

  private selectedDocumentName = '';
  private selectedDocumentUrl = '';

  private driverDocuments: {
    title: string;
    photoUrl?: string;
    expireDate?: number | null;
  }[] | undefined;

  private vehicleDocuments: {
    title: string;
    photoUrl?: string;
    expireDate?: number | null;
  }[] | undefined;

  protected dialogOpened() {
    if (this.driverInfo) {
      this.driverDocuments = [];
      this.driverDocuments.push(
        {
          title: this.$t('pages.trips.driverIdFront').toString(),
          photoUrl: this.driverInfo?.idFrontPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.driverIdBack').toString(),
          photoUrl: this.driverInfo?.idBackPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.driverLicense').toString(),
          photoUrl: this.driverInfo?.driverLicensePhoto,
          expireDate: this.driverInfo?.dtLicenseExpire,
        },
        {
          title: this.$t('pages.trips.healthReport').toString(),
          photoUrl: this.driverInfo?.healthReportPhoto,
          expireDate: this.driverInfo?.dtHealthReportExpire,
        },
        {
          title: this.$t('pages.trips.policeReport').toString(),
          photoUrl: this.driverInfo?.policeReportPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.gSCertificate').toString(),
          photoUrl: this.driverInfo?.gsCertificatePhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.ACVPass').toString(),
          photoUrl: this.driverInfo?.acvPassPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.portPermit').toString(),
          photoUrl: this.driverInfo?.portPermitPhoto,
          expireDate: null,
        },
      );
    } else {
      this.vehicleDocuments = [];
      this.vehicleDocuments.push(
        {
          title: this.$t('pages.trips.vehicleRegistrationCertificatePhoto').toString(),
          photoUrl: this.vehicleInfo?.vehicleRegistrationCertificatePhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.vehicleLicensePhoto').toString(),
          photoUrl: this.vehicleInfo?.vehicleLicensePhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.insurancePhoto').toString(),
          photoUrl: this.vehicleInfo?.insurancePhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.emissionReportPhoto').toString(),
          photoUrl: this.vehicleInfo?.emissionReportPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.inspectionReportPhoto').toString(),
          photoUrl: this.vehicleInfo?.inspectionReportPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.serviceRecordPhoto').toString(),
          photoUrl: this.vehicleInfo?.serviceRecordPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.ACVPass').toString(),
          photoUrl: this.vehicleInfo?.acvPassPhoto,
          expireDate: null,
        },
        {
          title: this.$t('pages.trips.portPermit').toString(),
          photoUrl: this.vehicleInfo?.portPermitPhoto,
          expireDate: null,
        },
      );
    }
  }

  private openDocumentImage(documentName: string, url: string) {
    this.selectedDocumentName = documentName;
    this.selectedDocumentUrl = url;
    // @ts-ignore
    this.$refs.imageDialog.open();
  }
}
